import {AppConfig} from '../../shared/config/app-config';
import {Injectable} from '@angular/core';
import {LocalStorageService} from '../services/local-storage.service';
import {StorageKeys} from '../../shared/models/storage-keys';
import moment, {Moment} from 'moment-timezone';


@Injectable()
export class BrowserHelper {

	private static BASE_URL = '';

	constructor(
		public config: AppConfig,
		public localStorage: LocalStorageService
	) {
		BrowserHelper.BASE_URL = this.config.BASE_URL;
	}

	toTimeZone(time: string, zone: string): Moment {
		return moment(time).tz(zone);
	}

	isTokenExpired() {
		const expiryTime = this.localStorage.get(StorageKeys.session_expiration);
		if (expiryTime) {
			const today = this.toTimeZone(new Date().toString(), this.config.TIME_ZONE);
			const expiry = parseInt(expiryTime, 10);
			if (today.unix() > expiry) {
				return true;
			}
		}
		return false;
	}

}
